@let tableName = this.tableName();
@let inside = this.inside();
@let logo = this.logo();

<ng-container coreActivitySection="Header">
  <app-button-back
    class="back"
    [text]="inside ? 'Back' : 'Close'"
    (click)="backButtonClick.emit($event)"
    [routerLink]="backButtonRouterLink()"
    [coreUserActivityClickTracking]="backButtonUserActivity()"
  />

  @if (logo) {
    <img class="logo" src="images/logo.webp" width="167" height="54" alt="logo"/>
  } @else {
    <div class="spacer"></div>
  }

  @if (tableName) {
    <div class="table">{{ tableName }}</div>
  } @else {
    <div class="spacer"></div>
  }
</ng-container>
